import { useLayoutEffect, useState, useRef } from 'react';

import { MAX_HEIGHT } from './messagePreview.consts';

export const usePreviewMask = () => {
  const [maskEnabled, setMaskEnabled] = useState(false);
  const ref = useRef<HTMLQuoteElement>(null);
  useLayoutEffect(() => {
    const actualHeight = ref.current?.offsetHeight ?? 0;
    setMaskEnabled(actualHeight > MAX_HEIGHT);
  }, [ref]);

  return {
    maskEnabled,
    ref,
  };
};
